// extracted by mini-css-extract-plugin
export default {"ButtonGroup":"IssueActions-module__ButtonGroup--VyDv0"};